export enum Chamber {
  NONE,
  SINGLE,
  DOUBLE,
  TWIN,
}
